import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card p-5 h-100"
}
const _hoisted_2 = { class: "card-header d-flex justify-content-end pb-4" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = {
  key: 0,
  class: "mt-7"
}
const _hoisted_5 = { class: "fs-1 mb-3" }
const _hoisted_6 = {
  key: 1,
  class: "mt-7"
}
const _hoisted_7 = { class: "fs-1 mb-3" }
const _hoisted_8 = {
  key: 2,
  class: "mt-7"
}
const _hoisted_9 = { class: "fs-1 mb-3" }

import { ref, inject, watch } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import BriefDetailTradeStat from "./BriefDetailTradeStat.vue";
import BriefDetailTradeStatSum from "./BriefDetailTradeStatSum.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BriefDetailModal',
  setup(__props, { expose: __expose }) {

const today = new Date();
const isLoading = ref(true);
const recordInfo = ref<any>(null);
const formRef = ref<InstanceType<typeof SimpleForm> | null>(null);

const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const period = ref([
  formatDate(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
  ),
  formatDate(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
  ),
]);

const modifiedPeriod = ref([]);

const handleDateChange = () => {
  const endDate = new Date(period.value[1]);
  endDate.setHours(23, 59, 59, 999);
  period.value[1] = formatDate(endDate);

  modifiedPeriod.value = period.value;
};

const search = async () => {
  isLoading.value = true;
  handleDateChange();
  isLoading.value = false;
};

const show = async (_item: any, _period: any) => {
  isLoading.value = true;
  formRef.value?.show();
  recordInfo.value = _item;
  period.value = _period;

  handleDateChange();
  isLoading.value = false;
};

const hide = () => {
  formRef.value?.hide();
};

__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "formRef",
    ref: formRef,
    "is-loading": isLoading.value,
    title: _ctx.$t('title.briefDetail'),
    "discard-title": _ctx.$t('action.close'),
    disableFooter: true,
    "min-height": 775,
    "min-width": 1000
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoadingCentralBox, {
            key: 0,
            class: "h-100"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_date_picker, {
                  modelValue: period.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
                  type: "datetimerange",
                  "start-placeholder": "Start date",
                  "end-placeholder": "End date",
                  "range-separator": "-",
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "success",
                  plain: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (search())),
                  loading: isLoading.value,
                  class: "ms-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            (recordInfo.value.mt4 != '' && recordInfo.value.mt5 == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("tip.mt4")) + " - " + _toDisplayString(recordInfo.value.name), 1),
                  _createVNode(BriefDetailTradeStat, {
                    accountId: null,
                    fromBrirfDetail: true,
                    accountNumbers: recordInfo.value.mt4,
                    name: recordInfo.value.name,
                    period: modifiedPeriod.value
                  }, null, 8, ["accountNumbers", "name", "period"])
                ]))
              : (recordInfo.value.mt5 != '' && recordInfo.value.mt4 == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("tip.mt5")) + " - " + _toDisplayString(recordInfo.value.name), 1),
                    _createVNode(BriefDetailTradeStat, {
                      accountId: null,
                      fromBrirfDetail: true,
                      accountNumbers: recordInfo.value.mt5,
                      name: recordInfo.value.name,
                      period: modifiedPeriod.value
                    }, null, 8, ["accountNumbers", "name", "period"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, "Summary - " + _toDisplayString(recordInfo.value.name), 1),
                    _createVNode(BriefDetailTradeStatSum, {
                      accountId: null,
                      fromBrirfDetail: true,
                      accountNumbers: recordInfo.value,
                      period: modifiedPeriod.value
                    }, null, 8, ["accountNumbers", "period"])
                  ]))
          ]))
    ]),
    _: 1
  }, 8, ["is-loading", "title", "discard-title"]))
}
}

})